var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","xl":"3"}},[_c('v-card',{attrs:{"elevation":"0","color":"white"}},[_c('v-card-text',{staticClass:"body-1"},[_c('vue-markdown',{attrs:{"source":_vm.homeText}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }